import axios from 'axios';
import { API_ENDPOINT } from '../../../index';

export const getProductCount = () => axios({
	url: `${API_ENDPOINT}/api/admin/analytics/products/total`,
	withCredentials: true
})

export const searchProducts = (value) => axios({
	url: `${API_ENDPOINT}/api/supplier/product/search/1?searchParam=${value}&limit=40&activeOnly=false`,
	withCredentials: true
})


// WEBPACK FOOTER //
// ./src/components/product/actions/index.js